var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHexagonEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 38,
    viewBox: "0 0 43 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bii_337_39797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.47564 22.6094C0.174786 20.3752 0.174786 17.6248 1.47564 15.3906L8.32861 3.62105C9.63311 1.38066 12.0474 1.37702e-07 14.6606 1.68864e-07L28.3394 3.31981e-07C30.9526 3.63143e-07 33.3669 1.38066 34.6714 3.62105L41.5244 15.3906C42.8252 17.6248 42.8252 20.3753 41.5244 22.6094L34.6714 34.3789C33.3669 36.6193 30.9526 38 28.3394 38L14.6606 38C12.0474 38 9.63311 36.6193 8.32861 34.3789L1.47564 22.6094Z",
    fill: "#19191E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.96832 21.7403C1.98026 20.0433 1.98026 17.9567 2.96832 16.2597L9.82129 4.49018C10.8134 2.78635 12.6562 1.72727 14.6606 1.72727L28.3394 1.72727C30.3438 1.72727 32.1866 2.78635 33.1787 4.49018L40.0317 16.2597C41.0197 17.9567 41.0197 20.0433 40.0317 21.7403L33.1787 33.5098C32.1866 35.2136 30.3438 36.2727 28.3394 36.2727L14.6606 36.2727C12.6562 36.2727 10.8134 35.2136 9.82129 33.5098L2.96832 21.7403Z",
    stroke: "#E9BE5C",
    strokeWidth: 3.45455
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bii_337_39797",
    x: -27.9422,
    y: -28.4422,
    width: 98.8845,
    height: 94.8845,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 14.2211
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_337_39797"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_337_39797",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.37573
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.18786
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_337_39797"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37.1937
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_337_39797",
    result: "effect3_innerShadow_337_39797"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagonEmpty);
export default __webpack_public_path__ + "static/media/hexagon-empty.7e39a2a2672602a4df9e261df2c46149.svg";
export { ForwardRef as ReactComponent };